import { useState, useEffect, useRef, Fragment, useContext } from 'react'
import { Button, Modal } from 'antd'
import { FormattedMessage, injectIntl } from 'react-intl'

import myContext from '@/utils/createContext';


const LinkPay = props => {
  const { intl, prePayment = 'default' } = props
  const { type } = useContext(myContext) || {}
  const { loading,
    actualPaymentAmount,
    actualPaymentCurrency } = useContext(myContext);
  const { formatMessage } = intl;


  const renderText = () => {
    const _html = <div className='product-text-666'>
        <p style={{textAlign:"center"}}>
          <FormattedMessage id={`${prePayment}.${type}.link.tip`} />
        </p>
        <div className='product-pay-icon-space' style={{marginTop: '30px', marginBottom:'30px'}}>
          <img src={`/static/images/${prePayment}/${type}.png`} alt={type} height="36px"/>
        </div>
    </div>
    return _html
  }

  return (
    <div>
      { renderText() }
      <div className="h5pc-submit">
        <Button
          className="h5pc-submit-btn"
          type="primary"
          htmlType="submit"
          loading={loading}
        >

          <span className="lock-img" ></span>
          {formatMessage({ id: 'ga-checkout.pay' })} &nbsp;
          {actualPaymentAmount} {actualPaymentCurrency}
        </Button>
      </div>
    </div>
  )
}

export default injectIntl(LinkPay)
